// Copyright © 2023 CATTLEytics Inc.
export enum Tool {
  CreatePolygonRegion = 'create-polygon-region',
  CreateRectRegion = 'create-rect-region',
  Default = 'default',
  DeleteRegion = 'delete-region',
  MoveRegion = 'move-region',
  NavigateToPen = 'navigate-to-pen',
}
